export default __webpack_public_path__ + "static/media/arrow-up.50a2765b.svg";